import EnhancedPostCard from '../post/EnhancedPostCard';
import { Bookmark } from 'lucide-react';

export const ProfileSaved = ({ savedPosts, onLike, onSave, onPostDelete, onPostUpdate, currentUserId }) => {
  if (!savedPosts || savedPosts.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-xl">
        <Bookmark className="w-12 h-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-600">No saved posts yet</p>
        <p className="text-sm text-gray-500 mt-1">Posts you save will appear here</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {savedPosts.map(post => (
        <EnhancedPostCard 
          key={post.id} 
          post={post}
          currentUserId={currentUserId}
          onPostDelete={onPostDelete}
          onPostUpdate={onPostUpdate}
        />
      ))}
    </div>
  );
};

export default ProfileSaved;
